// extracted by mini-css-extract-plugin
export default {"component":"TimeRemaining_component__hbF3z","info":"TimeRemaining_info__gMWhs","barContainer":"TimeRemaining_barContainer__BpTEy"};